import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type {
  IApiUpdateCategoryRequestBody,
  IApiUpdateCategoryResponseBody,
} from '../CategoriesApi.types';
import { useApi } from '~/lib/api/useApi';
import { categoriesQueryKeyFactory } from './useCategoriesQuery';
import { categoryQueryKeyFactory } from './useCategoryQuery';

export type IUseUpdateCategoryMutationValues = {
  appId: string;
  categoryId: string;
  body: IApiUpdateCategoryRequestBody;
};

export const useUpdateCategoryMutation = (): UseMutationResult<
  IApiUpdateCategoryResponseBody,
  unknown,
  IUseUpdateCategoryMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values) =>
      api.categories.update(values.appId, values.categoryId, values.body),
    onSuccess: async (_, values) => {
      // TODO once the API is updated to return updated category object
      // queryClient.setQueryData(
      //   categoryQueryKeyFactory({
      //     appId: updatedCategory.appId,
      //     categoryId: updatedCategory._id,
      //   }),
      //   updatedCategory,
      // );

      // In the meantime:
      await Promise.all(
        [
          {
            queryKey: categoryQueryKeyFactory({
              appId: values.appId,
              categoryId: values.categoryId,
            }),
          },
          {
            queryKey: categoriesQueryKeyFactory({
              appId: values.appId,
              parentCategoryId: values.categoryId,
            }),
          },
          {
            queryKey: categoriesQueryKeyFactory({
              appId: values.appId,
              parentCategoryId: values.body.parentId,
            }),
          },
        ].map((filters) => queryClient.invalidateQueries(filters)),
      );
    },
  });
};
